const VoterStats = () => {
  const stats = [
    {
      type: "SUPPORTIVE VOTERS",
      count: 800,
      change: "-0.2%",
      newCount: "-7 New",
      compare: "compare to 7 Days",
      color: "text-green",
      bgColor: "bg-green",
    },
    {
      type: "NEUTRAL VOTERS",
      count: 1229,
      change: "-9%",
      newCount: "+21 New",
      compare: "compare to 7 Days",
      color: "text-yellow-600",
      bgColor: "bg-yellow-500",
    },
    {
      type: "OPPOSIVE USERS",
      count: 301,
      change: "-12%",
      newCount: "+14 New",
      compare: "compare to 7 Days",
      color: "text-red-600",
      bgColor: "bg-red-500",
    },
  ];

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-2 px-4 rounded-lg border bg-secondary w-full">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex flex-col items-start justify-center text-left w-full mb-3 sm:mb-0 sm:text-center"
        >
          <div className="flex items-center mb-2">
            <span
              className={`w-[15px] h-[15px] rounded ${stat.bgColor} mr-2`}
            ></span>
            <span className="font-bold text-small-xs text-darkGrey">{stat.type}</span>
          </div>
          <div className="flex items-center gap-2">
            <p className="heading-medium font-bold text-darkGrey">{stat.count}</p>
            <p className={`text-small-xs ${stat.color} font-bold`}>{stat.change}</p>
          </div>
          <p className="mt-1 text-[8px] font-bold text-darkGrey">
            <span className={stat.color}>{stat.newCount}</span> {stat.compare}
          </p>
          <div className="w-full h-1 mt-2 overflow-hidden bg-grey rounded-full">
            <div className={`w-2/3 h-full ${stat.bgColor}`}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VoterStats;
